export default __webpack_public_path__ + "static/media/046-wine.e96d85b8.svg";